import React from 'react';
import { Img } from '@chakra-ui/react';
import {
  FlexPageWrapper,
  MaintenanceContainer,
} from '../styles/Maintenance.styles';
import { TTemplate } from '@/helpers/createTemplate';
import logo from '../../../assets/sterlingparker/images/logo-location-not-allowed.svg';
import Title from '../components/Title';
import Description from '../components/Description';
import ButtonRefresh from '../components/ButtonRefresh';

const { REACT_APP_THEME_NAME } = window.BETCLOUD_ENV;

const template = (isMaintenance: boolean): TTemplate => ({
  wrapper: <FlexPageWrapper isMaintenance={isMaintenance} />,
  content: {
    wrapper: <MaintenanceContainer />,
    logo: (
      <Img
        src={logo}
        alt={REACT_APP_THEME_NAME}
        h={['58px', null, '70px']}
        mt={['80px', null, '0']}
        mb={['0', null, '3']}
      />
    ),
    title: <Title />,
    desc: <Description />,
    btn: <ButtonRefresh />,
  },
});

export default template;
